module.exports = __webpack_public_path__ + "assets/img/loader.8c56dc67.gif";